import { CardElement } from "../types/battle"

function pickString(value: unknown, fallback = ""): string {
  if (typeof value === "string") return value
  if (value != null) return String(value)
  return fallback
}

export function normalizeCardElement(value: unknown): CardElement | null {
  const raw = pickString(value).toUpperCase()
  if (
    raw === "FIRE" ||
    raw === "WATER" ||
    raw === "EARTH" ||
    raw === "LIGHTNING" ||
    raw === "WIND" ||
    raw === "ICE"
  ) {
    return raw
  }
  return null
}
